// Development environment — used by default (ng serve, ng build without --configuration production).
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCCWowj-6Ca0wqiRULkKrZbOE7-PriiG3c',
    authDomain: 'dev-trishna-wiki.firebaseapp.com',
    projectId: 'dev-trishna-wiki',
    storageBucket: 'dev-trishna-wiki.firebasestorage.app',
    messagingSenderId: '666681214493',
    appId: '1:666681214493:web:2ce2493e2fd47c3710e8f4',
  },
};
